<template>
  <div :class="['productPage']">

    <div :class="['proSideMenu', showProSideMenu==false ? 'hidden':'']">
      <div class="proMenu">        
        <div class="links">
            <b>Learn more</b>
            <div style="padding-top:12px;">
              Prosthtic Options<br/>
              Conical Connection Catalog<br/>
              Tutorial Video              
              <!-- {{sectionsPos}} -->
            </div>
          </div>
          <a class="btn">View products </a>
      </div>      
    </div>

    <div class="proSection sticky">
        <div class="background" style="background:#fff">
         <prosection
            :itemIndex = "0"
            :mode="sticky"
            :frame-count="50"
            @onViewChange="onViewChange"
            frame-path="video/sequnces/lynx1/lynx_bg1_{i}.webp"  >        
            <div class="content">
                <img src="lynx/img/lynx.svg" class="psLogo"/>
                <div class="psTitle">
                    NextGen Simplicity.
                </div>    
            </div>          
         </prosection>
        </div>
    </div>

    <!-- <div class="proSection sticky"> -->
    <div class="proSection sticky">
        <div class="background" style="background:#fff">
         <prosection
            :itemIndex = "1"
            :mode="sticky"
            :frame-count="15"
            @onViewChange="onViewChange"
            frame-path="video/sequnces/lynx2/lynx_bg2_{i}.webp"  >
          <div class="content">
              <div class="psTitle">
                  Adaptive Placement for Surgical Simplicity.
              </div>    
          </div>
         </prosection>
        </div>
    </div>

    <div class="proSection sticky">
        <div class="background" style="background:#fff">
         <prosection
            :itemIndex = "2"
            :mode="sticky"
            :frame-count="50"
            @onViewChange="onViewChange"
            frame-path="video/sequnces/lynx3/lynx_bg3_{i}.webp">
          <div class="content">
              <div class="psTitle">
                C1 XD<br/>
                MIS XD Single-Use Drills
              </div>    
              <div class="psDesc">
                Unique in the market, MIS provides sharp and sterile XD drills with each implant, 
                designed for single use. XD drills are used once per procedure, ensuring strict clinical 
                hygiene protocols for clinicians and patients.                
              </div>  
          </div>
         </prosection>
        </div>
    </div>    


    <!-- //////////// TECHNICAL INFORMATION ////////////-->
    <div class="proSection Technical">
        <div class="content">
            <div class="psTitle">Technical Information</div>    
            <div class="techTabs">
              <ul>
                <li @click="featureIndex=index"
                  v-for="(item,index) in featuresMenu" :key="'feature_'+index" 
                  :class="[index == featureIndex ? 'selected':'']">
                  {{item}}
                </li>                
              </ul>
            </div>
            <div class="techContents" v-if="minisite_data">
                <div :class="['tabPanel',featureIndex==0 ? 'visible':'']">
                  <techrange :sectionDataIndex="2"></techrange>
                </div>
                <div :class="['tabPanel',featureIndex==1 ? 'visible':'']">
                  <techinfo :sectionDataIndex="3" ></techinfo>
                </div>
                <div :class="['tabPanel',featureIndex==2 ? 'visible':'']">
                  <techfeat></techfeat>
                </div>
                <div :class="['tabPanel',featureIndex==3 ? 'visible':'']">
                  <techpackage :sectionDataIndex="8"></techpackage>
                </div>
                <div :class="['tabPanel',featureIndex==4 ? 'visible':'']">
                  <techdrilling :sectionDataIndex="4"></techdrilling>
                </div>
            </div>
        </div>
    </div>

    <div class="proSection Technical">
        <div class="content">
            <div class="psTitle">
                Clinical Cases
            </div>

        </div>
    </div>



  </div>
</template>

<style >
    .productPage
    {
        width: 100%;
        min-height: 50vh;
        position: relative;
        top: -100px;
    }

    .proSideMenu
    {
      position: fixed;
      top: 0px;
      right: 6vw;
      height: 100%;
      width: 18vw;
      z-index: 500;
      display: flex;
      align-items: center;
      transition: all ease 0.5s;
    }
    .proSideMenu.hidden
    {
      right: -20vw;
    }

    .proMenu
    {      
      width: 100%;
      min-height: 10vw;      
      margin: auto;
      border-radius: 18px;
      padding: 40px 40px 45px 40px;
      background-color:#1894e2;color: #fff;
      /* border: solid 1px #202020;backdrop-filter: blur(5px); */
    }
    .proMenu .btn
    {
        
        font-weight: 500 !important;
        border-radius: 30px;
        padding: 10px 20px;
        /* border: solid 2px #202020;  color: #202020;     */
        border: solid 2px #fff;  color: #fff;
    }
    .proMenu .links
    {
      display: block;
      padding-bottom: 35px;
    }
    .proMenu .links b
    {
      font-size: 30px;
    }
    .proMenu .links a
    {
      color: #fff;
      font-size: 12px;
    }

    .proSection
    {
        width: 100vw;
        /* height: calc(100vh - 90px);         */
        height: 100vh;
        position: relative;
    }
    .proSection.sticky
    {
      height: 200vh;
      position: sticky;
    }


    .proSection .background
    {
        position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;
        background-color: #202020;
        z-index: 100;
    }
    .proSection .background video
    {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .proSection .content
    {
        position: sticky;
        top: 0px;left: 0px;
        width: 100%;
        height: 100vh;
        padding: 0px 5vw;

        display: flex;
        flex-direction: column;   /* stack vertically */
        justify-content: center;  /* center vertically */
        align-items:flex-start;      /* center horizontally */


    }
    .psLogo
    {
      width: auto;
      height: 6vw;
      text-align: left;
    }
    .psTitle{
        width: 40vw;
        font-size: 52px;color: #202020;
        letter-spacing: -3px !important;
    }
    .psDesc{
        padding-top: 20px;
        width: 35vw;
        font-size: 16px;
        color: #202020;
        display: block;        
    }


    .proSection.Technical
    {
      height: auto;
    }
    .proSection.Technical .content
    {
        position:initial;
        height: auto;
        display: block; 
        padding: 5vw 5vw 0 5vw;
    }



    .techTabs
    {
      margin-top: 50px;
      padding: 36px 60px 60px 40px;      
      border-radius: 20px;
      width: auto;
      display: inline-block;
      /* background: #f9f9f9;border: solid 1px #202020; */
      background: #6b6b6b;border: solid 0px #202020;
    }
    .techTabs ul
    {
      list-style: none;
      display: flex;
      flex-direction: row;
      column-gap: 40px;
      flex-shrink: 0;
    }
    .techTabs li
    {
      color: #fff;
      font-weight: 300 !important;
      opacity: 0.7;
      cursor: pointer;
    }
    .techTabs li.selected
    {
      color: #fff;
      font-weight: 500 !important;
      opacity: 1;
    }

    .techContents
    {
      /* border: solid 1px #202020;background-color: #fff; */
      border: solid 0px #202020;background-color: #f9f9f9;
      width: 100%;
      min-height: 70vh;
      height: 70vh;      
      border-radius: 20px;
      position: relative;
      top: -30px;
    }
    .tabPanel
    {
      width: 100%;
      height: 100%;
      display: none;
    }
    .tabPanel.visible
    {
      display: block;
    }

</style>



<script>

    import prosection     from "@/views/products/com/ProSection.vue";
    import techrange      from "@/views/products/com/TechRange.vue";
    import techinfo      from "@/views/products/com/TechInfo.vue";
    import techfeat      from "@/views/products/com/TechFeatures.vue";
    import techpackage      from "@/views/products/com/TechPackage.vue";
    import techdrilling      from "@/views/products/com/TechDrilling.vue";
    
  /* import SeqSection from "./SeqSection.vue";  */
  import { mapActions, mapState } from "vuex";  
  export default 
  {
    components:
    {
        prosection,techrange,techinfo,techfeat,techpackage,techdrilling
    },
    data(){
      return{
        featuresMenu:['Implant range','Dimensions','Features','Package Contents','Drilling Procedure'],
        featureIndex:0,
        showProSideMenu:true,
        sectionsPos:[0,0,0,0,0],
        visibleSection:0,
        activeIndex: 0,
        children:[],
        sectionsProgresses:[
            {prog:0,time:0,videoID:'proVid0'},
            {prog:0,time:0,videoID:'proVid1'}
        ],
        progress:100,
        minisite_ready:false,        
        minisite_data:null,
        minisite_dictionary:null,
      }
    },  
    computed: {
        //...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),
    },
    created()  
    {            
        var vm = this;
        //this.setPageReady(false);
        //this.initScrollListener();
        setTimeout(() => {
          vm.loadData();  
        }, 1000);
        
        //this.setPageReady(true);
    },
    mounted()
    {
        var vm=this;
        //vm.progress=20000;
        vm.initScrollListener();
    },

    methods:
    {
      ...mapActions(["setMinisiteData","setMinisiteDic","xSetPlatform","initRouteByCid","setPageReady"]),
      onViewChange(data)
      {
          if(data.index==2)
          {
            //alert("element2 visible:"+data.val);
          }
          //this.sectionsPos[data.index] = data.val;
      },
      getLangByRoute()
      {
        let lc = this.$route.params.lang;
        if(lc == undefined){lc="en";}
        return lc;
      },
      loadData() 
      {
        //let lc = this.getLangByRoute();                
        this.loadSiteData("site_data.json");
      },
      loadSiteData(fileName)
      {
        var vm = this;
        //vm.loadProductData();        
        //LOAD CONTENTS FROM JSON           
        var APP_SITE_NAME = "seven";//var APP_SITE_NAME = "lance";
        var apiURL = "content/"+APP_SITE_NAME+"/data/"+fileName;//e.g:"/site_data.json";
        fetch(apiURL, 
        {
            method: "GET",cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
        })
        .then(function(response){ return response.json();})
        .then(function(response){
            if(fileName=="site_data.json"){
              vm.minisite_data = response;
              vm.setMinisiteData(response);
              vm.loadSiteData("site_dictionary.json");
            }
            if(fileName=="site_dictionary.json"){
              vm.minisite_dictionary = response;
              vm.setMinisiteDic(response);
              vm.minisite_ready = true;              
            }
          }        
        );
      },        
      loadProductData()
      {
          //load the product page data from the admin 
          //clinical cases / publications / links sections
          //this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
          //page/3390
          //https://api.mis-implants.com/api/page/3390          
          //FIND THE _cid BY THE PAGE PATH (CHECK PAGE.VUE) 
          var _cid = 3390; //seven         
          this.initRouteByCid(_cid); 
          //this.initRouteByCid(item.cid);
      },

      initScrollListener() 
      {
      var vm=this;
      //let isM = isMobileScreen();
      //vm.sectionsProgresses[0]=1;
      
      setTimeout(() => {    
        //if(isMobileScreen()==false)
        //{
          //var scrollContainer = document.getElementById("mainScroller");
          //scrollContainer.addEventListener("scroll", vm.scrollHandler, false);    
        //}else
        //{
          document.addEventListener("scroll", vm.scrollHandler, false);
        //}
      }, 1000);
    },    
    scrollHandler() {      
      var vm=this;      
      this.checkSectionsView();      
    },
    getElementScrollPosition(el) {
      const rect = el.getBoundingClientRect();
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom < 0) {
        // Element is completely above the viewport
        return 'above';
      } else if (rect.top > viewHeight) {
        // Element is completely below the viewport
        return 'below';
      } else {
        // Element is (at least partially) visible
        return 'visible';
      }
    },
    checkSectionsView()
    {
      var sectionElements = document.querySelectorAll(".proSection");
      var secondElement = sectionElements[1];
      var secondPos = this.getElementScrollPosition(secondElement);
      if(secondPos=='above')
      {
        this.showProSideMenu=false;
      }else{
        this.showProSideMenu=true;
      }
    },
    ___checkSectionsView()
    {      
      var vm=this;
      var wHeight = window.innerHeight;

        //alert("check1");
      var reveals = document.querySelectorAll(".proSection");
      for (var i = 0; i < reveals.length; i++) 
      {
        //var curElement = reveals[i];    
        var elRect = reveals[i].getBoundingClientRect();
        var elementTop = reveals[i].getBoundingClientRect().top;
        //var elementVisible = windowHeight*1;//350;

        var scrollTop = wHeight - elRect.top; 
        //var scrollHeight = elRect.height + window.innerHeight;
        vm.sectionsPos[i] = scrollTop;



        /*
        // clamp between 0 and 1
        const scrollFraction = Math.min(Math.max(scrollTop / scrollHeight, 0), 1);
        var videoEl = document.getElementById(vm.sectionsProgresses[i].videoID);
        var duration = 3;
        var videoTime = scrollFraction * duration;
        vm.sectionsProgresses[i].time=videoTime;
        videoEl.currentTime = videoTime;
        */

        //if(curElement.classList.contains('sequence'))
        //{
/*             let secHeight = elRect.height;
            let scrollWay = secHeight - windowHeight;
            let precentageOfSequence = Math.round(Math.abs(elementTop-90)/secHeight*100);
            let sectionProg = precentageOfSequence/100;
            vm.sectionsProgresses[i].prog=sectionProg;
            var videoTime = 6*sectionProg;//2 sec video test
            vm.sectionsProgresses[i].time=videoTime;
            var videoEl = document.getElementById(vm.sectionsProgresses[i].videoID);
            videoEl.currentTime = videoTime;
 */

            //vid.currentTime = 5;

            if (elementTop < 0 && elementTop > 0 - scrollWay)// && elementTop>0)
            {
              
              //CALCULATE THE PRECENTAGE OF THE ELEMENT SEQUENCE
              //let precentageOfSequence = Math.round(Math.abs(elementTop/scrollWay) * 100);
              //let sectionProg = precentageOfSequence/100;
              //let secIndex = i>0 ? i-1 : 0; //get the data index and not the dom index
              

              //this.setSectionProgress({index:sectionIndex,prog:sectionProg});
              //vm.sectionsProgresses[sectionIndex]= sectionProg;
            }
        //}
        //*/

      }
    },
    onSectionVisible(domSectionIndex)
    {
        
        var vm=this;
        //let sectionIndex = domSectionIndex;
        //let sectionDataIndex = sectionIndex;
        //var sectionElement = document.querySelectorAll(".siteSection")[domSectionIndex];
        //this.revealSectionChildrenElements(sectionElement,domSectionIndex);
    },    
    revealSectionChildrenElements(parentElement,domSectionIndex) 
    {
      var vm=this;
      //parentElement.classList.add("active");
      //var reveals = parentElement.querySelectorAll(".reveal");
      //for (var i = 0; i < reveals.length; i++){
          //if(reveals[i].classList.contains("active")==false){
            //vm.onRevealingSection(reveals[i].id);
            //reveals[i].classList.add("active");
          //}
      //}
    },
    onRevealingSection(sectionID)
    {
        //add here specific site logic ...
    },       
    setActiveIndex(index)
    {
        this.activeIndex = index;
    }
  }
  }
</script>


